import TitleBarWidget from './TitleBarWidget';

export default TitleBarWidget;
